import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const isGeneralLabel = (value?: string | null) =>
  (value || "").trim().toLowerCase().startsWith("general");

export function sortGeneralFirst(values: string[]) {
  return [...values].sort((a, b) => {
    const aGeneral = isGeneralLabel(a);
    const bGeneral = isGeneralLabel(b);
    if (aGeneral && !bGeneral) return -1;
    if (!aGeneral && bGeneral) return 1;
    return a.localeCompare(b, undefined, { sensitivity: "base" });
  });
}

export function sortGeneralFirstByName<T extends { name?: string | null }>(items: T[]) {
  return [...items].sort((a, b) => {
    const aName = (a.name || "").trim();
    const bName = (b.name || "").trim();
    const aGeneral = isGeneralLabel(aName);
    const bGeneral = isGeneralLabel(bName);
    if (aGeneral && !bGeneral) return -1;
    if (!aGeneral && bGeneral) return 1;
    return aName.localeCompare(bName, undefined, { sensitivity: "base" });
  });
}
